import React from 'react'
import {OpenIdClient} from '@client/openid-client'
import {Backend} from '@common/backend'
import {ButtonNew} from '@components/common/base/buttons'

export const OpenIdSignIn = () => {
  if (!Backend.initResponse?.openId) {
    return <></>
  }

  return (
    <div className="mt-16 flex justify-center">
      <ButtonNew onClick={() => OpenIdClient.authenticate()}>
        {Backend.initResponse.openId.signInButtonText}
      </ButtonNew>
    </div>
  )
}
